var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { ref: "pbiContainer", staticClass: "pbi-container" }, [
      _vm.isLoading ? _c("span", [_vm._v("Fetching token...")]) : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }